import script from "./TabListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabListItem.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=2d2b3b34&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2b3b34"]])

export default __exports__